import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * `twMerge`, taught about this project's named radius rungs.
 *
 * Without the extension, `cn('rounded-md', 'rounded-control')` keeps BOTH:
 * tailwind-merge only knows the radius scale it ships with, so a theme key it
 * has never heard of looks like an unrelated utility rather than a conflicting
 * one. Both classes then reach the DOM and the winner is decided by stylesheet
 * order — which is how the landing page's submit button rendered at 6px
 * (`rounded-md`, from the shared `Button` base) beside a 8px input, while the
 * class list said `rounded-control`.
 *
 * The rungs are defined in `globals.css` under `--radius-badge` / `-control` /
 * `-card`. Adding one there means adding it here.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [{ rounded: ['badge', 'control', 'card'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
